import React from 'react';
import { Link } from 'react-router-dom';

export default function GettingStarted() {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-semibold text-brand1-dark">Start Here</h1>

      <p className="text-muted">
        Welcome to CoreCompass™. This guide shows roles, navigation, and common workflows.
      </p>

      <div className="rounded-2xl border border-app bg-app p-5 shadow-sm">
        <h2 className="text-lg font-semibold text-brand1-dark">Roles</h2>
        <ul className="list-disc pl-5 text-sm text-muted mt-2 space-y-1">
          <li><strong>Viewer</strong>: Access free tools like Market Data</li>
          <li><strong>Org</strong>: Access paid apps such as TradeTracker</li>
          <li><strong>Admin</strong>: Manage users, access, and uploads</li>
        </ul>
      </div>

      <div className="rounded-2xl border border-app bg-app p-5 shadow-sm">
        <h2 className="text-lg font-semibold text-brand1-dark">Quick links</h2>
        <div className="mt-2 flex flex-wrap gap-3 text-sm">
          <Link className="underline" to="/market-map">Open MarketMap</Link>
          <Link className="underline" to="/trade-tracker">Open TradeTracker</Link>
          <Link className="underline" to="/kb/trade-tracker">TradeTracker guide</Link>
          <Link className="underline" to="/faq">FAQs</Link>
          <Link className="underline" to="/kb/support">Contact support</Link>
        </div>
      </div>
    </div>
  );
}
